export default __webpack_public_path__ + "static/media/apache_cloudstack.fccc21f6.svg";